import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";

// assets start
export const DESKTOP_ONLY_FEATURE_ASSET_SRC = getS3AssetCDNUrl(
  "assets/vectors/common/desktop_only_feature.svg"
);
// assets end
